window.registerOrderDetailComponent = function(app) {
app.component('orderDetail',
    {   props: ['order', 'img', 'api', 'wd', 'mobile', 'index'],
        data(){
            return {
                timer: this.order.timer,
                smsTimer: null,
                time: 601,
                other_sms_list: [],
                isFullSms: false,
                listenTimer: false,
                isVoice: false,
                serviceName: null,
                country: null,

                waitingStep: 0,
                waitingShowLoading: false,
                nextStepWaiting: 60,
                waitingInfoText: {
                    waitingSms: $L('ords.gettingSMS') + " <img v-else src='/templates/New_Design_Multilang/images/loader_service.svg'>",
                    serviceIsDelayed: $L('ords.ord_message_serviceIs_delayed'),
                    checkingTheServiceForSending: $L('ords.ord_message_checking_service_for_sending'),
                    blockedServiceByIp: $L('ords.ord_message_blocked_service_by_Ip'),
                    problemReceivingSms: $L('ords.ord_message_problem_receiving_sms'),
                    checkDataCorrect: $L('ords.ord_message_check_data_correct'),
                },

                hideSmsRequestTimeoutId: null,

                availableNewMessage: null,

                canMakeHiddenRequest: false,

                isPaid: false,

                createHideRequestTimeoutId: null,

                // CHANGE 
                decryptLoading: false,
                decryptMessage: "",
                decryptTimeout: null
            }   
        },
        watch: {

            'order.setTimer'(){
                this.order.secondsleft = this.order.setTimer
                this.time = this.order.setTimer
            },

            // time(){
            //     console.log( this.order.number + " - " + this.time )
            // },
            /**
             * Функция  `order`  является асинхронной и содержит несколько условий для обработки заказа.
             *
             * Сначала устанавливается значение  `isFullSms`  в  `false` . Затем проверяется, есть ли голосовое
             * сообщение в заказе. Если есть, то значение  `isVoice`  устанавливается в  `true` .
             *
             * Затем проверяется значение  `time` , которое указывает на количество оставшихся секунд до завершения
             * заказа. Если значение  `time`  меньше 1, то статус заказа устанавливается в 3.
             *
             * Если значение  `code`  в заказе не пустое, то статус заказа устанавливается в 2.
             *
             * Если статус заказа равен 0, то выводится сообщение "Buy new" и вызывается функция  `getNumber`  с
             * передачей данных для покупки.
             *
             * В противном случае, если статус заказа не равен 2 и не равен 3, вызываются функции  `startTimer`  и
             * `getSms` , а также обрабатывается объект  `order` .
             */
            async order() {
                this.isFullSms = false
                this.isVoice = !! this.parseVoiceMessage (this.order.fullSMS);

                this.time = this.order.secondsleft

                if (this.order.code !== '') {
                    this.order.status = 2
                }
                if (this.time < 1) {
                    this.order.status = 3
                }

                if (this.order.fullSMS) {
                    this.isFullSms = true
                }

                if (this.order.status === 0) {
                    console.log ('Buy new')
                    console.log (await this.getNumber (this.order.dataToBuy))
                } else if (this.order.status !== 2 && this.order.status !== 3) {
                    this.startTimer()
                    this.getSms()
                    this.order
                }

            },
        },
        methods:{

            hasPhoneNumber() {
                const number = this.order && this.order.number
                const countryCode = this.order && this.order.countrycode

                return number !== undefined && number !== null && String(number).trim() !== '' &&
                    countryCode !== undefined && countryCode !== null && String(countryCode).trim() !== ''
            },

            startWaitDecrypt() {
                if (
                    this.decryptLoading || !this.order || 
                    !this.order.countrycode || !this.order.number 
                ) return 

                this.decryptLoading = true
                this.waitDecryptMessage()
            },

            async waitDecryptMessage() {

                if (!this.order || !this.order.countrycode || !this.order.number ) return 

                if (this.decryptTimeout) clearTimeout(this.decryptTimeout)

                let phone = (this.order.countrycode + this.order.number).replace(/^\+/, '')

                let data = new FormData()
                data.append('method', 'GET_DECRYPTED_MESSAGE')
                data.append('pNumber', phone)

                let res = await axios({method: 'post', url: '/sms_api/orders.php?n=decrypted', data: data})

                if (!res || !res.data || !res.data.hasOwnProperty('status')) {
                    this.$emit('notify', $L('ords.failed_decrypted'))
                    return
                } 

                if (this.decryptTimeout) clearTimeout(this.decryptTimeout)

                switch(res.data.status) {
                    case "OK":
                        this.decryptMessage = res.data.message
                        this.decryptLoading = false
                        break;
                    case "WAIT":
                        console.log("WAITE")
                        this.decryptTimeout = setTimeout(() => {this.waitDecryptMessage()}, 5000)
                        break;
                    case "ERROR":
                    case 0:
                        this.$emit('notify', $L('ords.failed_decrypted_task_not_found') + phone)
                        this.decryptLoading = false
                        break;
                }

            },

            // 
            showNewMessage() {
                if (this.availableNewMessage && this.availableNewMessage.code) {
                    this.order.status = 2
                    this.order.code = this.availableNewMessage.code
                    this.order.fullSMS = this.availableNewMessage.fullSMS ? this.availableNewMessage.fullSMS : ""
                    if (this.order.fullSMS) {
                        if (this.parseVoiceMessage(this.order.fullSMS)) {
                            this.isVoice = true
                        } else {
                            this.isVoice = false
                        }
                        this.isFullSms = true
                    }
                }
                this.availableNewMessage = null
            },  

            hideSmsRequest() {

                if ((this.order.opt != 'opt29' && !(this.order.opt == 'opt20' && this.order.country == 'US')) || !this.canMakeHiddenRequest) {
                    clearTimeout(this.hideSmsRequestTimeoutId)
                    return
                }

                if (this.hideSmsRequestTimeoutId) {
                    clearTimeout(this.hideSmsRequestTimeoutId)
                }

                this.api.getCode({
                    serviceId: this.order.opt,
                    id: this.order.id,
                    country: this.order.country
                }).then(async (response) => {
                      
                    response = response.split('~')

                    if (response[0] != 1) {
                        if (this.time != 0 && this.time != '-') {
                            console.log("Current time:" + this.time)
                            this.hideSmsRequestTimeoutId = setTimeout(() => {
                                this.hideSmsRequest()
                            }, 10000)
                        }
                        return
                    }

                    if ((this.order.opt == 'opt29' || (this.order.opt == 'opt20' && this.order.country == 'US')) && this.order.code) {

                        this.availableNewMessage = {
                            code: response[2],
                            fullSMS: response[3]
                        }

                        this.createHideRequestTimeoutId = setTimeout(() => { this.createHideRequest() }, 10000)

                        this.$emit('got-number')

                    } else {
                        this.order.status = 2
                        this.order.code = response[2]
                        this.order.fullSMS = response[3]

                        if (this.order.fullSMS) {
                            if (this.parseVoiceMessage(this.order.fullSMS)) {
                                this.isVoice = true
                            }
                            this.isFullSms = true
                        }
                    }
                    
                    
                }).catch(function(ex) {
                    console.log(ex)
                    console.log(ex.stack)
                    clearTimeout(this.hideSmsRequestTimeoutId)
                    this.smsTimer = setTimeout( this.hideSmsRequest.bind( this ), 20000)
                }.bind( this ) )
                
            },

            createHideRequest() {
               
                if ((this.order.opt != 'opt29' && !(this.order.opt == 'opt20' && this.order.country == 'US')) || !this.canMakeHiddenRequest) {
                    return
                }

                if (this.createHideRequestTimeoutId) {
                    clearTimeout(this.createHideRequestTimeoutId)
                }

                this.api.checkRepeatCode({ id: this.order.id }).then((res) => {

                    if (res !== 0) {
                        res = res.split('~')

                        if (res[0] === 'queued') {
                            this.createHideRequestTimeoutId = setTimeout(() => { this.createHideRequest() }, 10000)
                        }
                        else if (res[0] === '1') {
                            this.hideSmsRequest()
                            // this.availableNewMessage = null
                        } 
                    }
                }).catch(function(ex) {
                    this.createHideRequestTimeoutId = setTimeout(() => {this.createHideRequest()}, 10000)
                }.bind( this ) )

            },

            waitingText (waitingStatus = 0) {

                switch (waitingStatus) {
                    case 1: 
                        return this.waitingInfoText.serviceIsDelayed
                    case 2:
                        return this.waitingInfoText.checkingTheServiceForSending
                    case 3:
                        return this.waitingInfoText.blockedServiceByIp
                    case 4:
                        return this.waitingInfoText.problemReceivingSms
                    case 5:
                        return this.waitingInfoText.checkDataCorrect
                    default:
                        if (this.order.country == "US" && this.waitingInfoText.hasOwnProperty('us_info')) {
                            return this.waitingInfoText.us_info
                        } else {
                            return this.waitingInfoText.waitingSms
                        }
                }

            },  

            waitingCheck () {

                if (Object.values(this.waitingInfoText).length <= this.waitingStep) {
                    this.waitingStep = 0
                    // 
                    this.nextStepWaiting = 60
                    this.waitingShowLoading = false
                    return false
                }

                if (this.nextStepWaiting > 0) {
                    this.nextStepWaiting -= 1
                    return false
                } 
                
                if (!this.waitingShowLoading) {
                    this.waitingShowLoading = true
                    setTimeout( function () {
                        this.waitingStep += 1
                        // 
                        this.nextStepWaiting = 60
                        this.waitingShowLoading = false
                    }.bind(this), 4500 )
                }

                // if (this.order.status == 1 && Object.values(this.waitingInfoText).length > this.waitingStep) {

                //     if (this.nextStepWaiting > 0) {
                //         this.nextStepWaiting -= 1
                //     } else if (!this.waitingShowLoading) {
                //         this.waitingShowLoading = true
                //         setTimeout( function () {
                //             this.waitingStep += 1
                //             this.nextStepWaiting = 60
                //             this.waitingShowLoading = false
                //         }.bind(this), 4500 )
                //     }

                // } else if (Object.values(this.waitingInfoText).length <= this.waitingStep) {
                //     this.waitingStep = 0
                //     this.nextStepWaiting = 60
                //     this.waitingShowLoading = false
                // }
            },

            async getPrice() {

                let data = new FormData()
                data.append('method', 'GET_PRICE_BY_SERVICE_AND_COUNTRY')
                data.append('service',  this.order.opt )
                data.append('country', this.order.country )

                let res = await axios({method: 'post', url: '/sms_api/orders.php?n=9999', data: data})

                if (res.data.hasOwnProperty('karma')) {
                    this.ratingToView = res.data.karma
                }

                const response = res && res.data ? res.data.response : false

                if (response && response.data && response.data && this.order.operator) {

                    const operator = this.order.operator == 'Total_' + this.order.country ? 'Other_' + this.order.country : this.order.operator

                    return Number( response.data[operator] )
                }
                return 0
            },   

            async sendMetrics(event){
                // if (typeof window.gtag != 'undefined') {
                //     gtag('event', event)
                // }else {
                //     console.log('Metrics not initialized');
                // }
            },

            /**
             * Функция  startTimer  запускает таймер и устанавливает флаг  listenTimer  в значение  true .
             */
            async startTimer(){
                this.listenTimer = true
            },

            /**
             * Функция  stopTimer  останавливает таймер, вызывает функцию  stopGettingSms  и устанавливает флаг
             * listenTimer  в значение  false . Также сбрасывает значение переменной  time  на "-".
             */
            async stopTimer() {
                await this.stopGettingSms()
                this.listenTimer = false
                this.time = '-'
            },

            /**
             * Функция  secondsToMinutes  преобразует переданное количество секунд в формат "минуты:секунды" и
             * возвращает строку.
             */
            secondsToMinutes(seconds) {
                const minutes = Math.floor(seconds / 60);
                const remainingSeconds = seconds % 60;
                const formattedSeconds = remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds;
                return `${minutes}:${formattedSeconds}`;
            },

            /**
             * Функция  getNumber  отправляет запрос на получение номера и обрабатывает ответ. В зависимости от
             * полученного ответа выполняются различные действия, такие как установка значений для свойств объекта
             * order , вызов других функций и генерация событий.
             */
            async getNumber(){

                const dataToBuy =  this.order && this.order.hasOwnProperty( 'dataToBuy' ) ? this.order.dataToBuy : false

                if( !dataToBuy ){
                    return false
                }
                
                this.order.country = this.order.dataToBuy && this.order.dataToBuy.hasOwnProperty( 'country' ) ? this.order.dataToBuy.country : false

                await this.api.getNumber(dataToBuy)
                    .then((response) => {
                        response = response.split('~')

                        switch (response[0]) {
                            // success
                            case 'ok':
                                this.order.number = response[1]
                                this.order.id = response[2]
                                this.order.countrycode = response[3]
                                this.order.secondsleft = parseInt(response[4])
                                this.time = this.order.secondsleft
                                this.order.status = 1

                                window.smspvaTrackEvent(
                                    'activation_order_created',
                                    window.smspvaActivationParams(this.order, {
                                        number_issued: true,
                                    }),
                                    this.order.id
                                )

                                this.$emit('got-number')
                                clearTimeout(this.smsTimer)
                                this.startTimer()
                                this.getSms()
                                this.sendMetrics("doneservice")

                                if (this.order.fullSMS) {
                                    this.isFullSms = true
                                }


                                break;
                            case 'net_modema':
                                clearTimeout(this.smsTimer)
                                this.smsTimer = setTimeout(this.getNumber, 30000)
                                break;
                            case 'queued':
                                // console.log( "queued get number")
                                clearTimeout(this.smsTimer)
                                this.smsTimer = setTimeout(this.getNumber, 1000)
                                break;
                            case '5' || 5:
                                this.$emit('notify', $L('ords.reqLimit') )
                                this.$emit('delete')
                                break;
                            case '6' || 6:
                                this.$emit('notify', $L('ords.tempBanned') )
                                this.$emit('delete')
                                break;
                            case '7' || 7:
                                this.$emit('notify', $L('ords.threadLimit'))
                                this.$emit('delete')
                                break;
                            case 'error1':
                                window.orderPageAlert($L('ords.failed_create_order'))
                                this.$emit('delete')
                                break;
                            case 'error2':
                                this.$emit('notify', $L('ords.needAuth'))
                                this.$emit('delete')
                                break;
                            case 'error':
                                this.$emit('notify', $L('ords.lowFunds'))
                                this.$emit('delete')
                                break;
                            case 'error_unconf':
                                this.$emit('notify', $L('ords.unconfEmail'))
                                this.$emit('delete')
                                break;
                            default:
                                throw new Error('Error')
                        }

                        const failureReasons = {
                            '5': 'rate_limit',
                            '6': 'temporary_ban',
                            '7': 'concurrency_limit',
                            'error1': 'create_order_failed',
                            'error2': 'auth_required',
                            'error': 'insufficient_balance',
                            'error_unconf': 'email_unconfirmed',
                        }
                        const failureReason = failureReasons[response[0]]

                        if (failureReason) {
                            window.smspvaTrackEvent(
                                'activation_failed',
                                window.smspvaActivationParams(this.order, {
                                    failure_stage: 'order_create',
                                    failure_reason: failureReason,
                                }),
                                this.order.analyticsRequestId || this.order.id
                            )
                        }

                    })
                    .catch( function(ex) {
                        window.smspvaTrackEvent(
                            'activation_failed',
                            window.smspvaActivationParams(this.order, {
                                failure_stage: 'order_create',
                                failure_reason: 'network_or_unknown_response',
                            }),
                            this.order.analyticsRequestId || this.order.id
                        )

                        this.$emit( 'notify', '')
                        this.$emit( 'delete' )
                        clearTimeout( this.smsTimer )
                        console.log('Error while getting number: ', ex)
                        console.error(ex.stack)
                    }.bind( this ) )
            },

            /**
             * ункция  getAdditionalSms  отправляет запрос на получение дополнительного SMS-сообщения и обрабатывает
             * ответ. В зависимости от полученного ответа выполняются различные действия.
             */
            async getAdditionalSms() {

                let balance = document.querySelector('#user-balance-val')
                balance = balance ? Number(balance.innerHTML) : 0 

                if (balance < this.order.price && (this.order.opt != 'opt29' && !(this.order.opt == 'opt20' && this.order.country == 'US'))) {
                    this.$emit('notify', $L('ords.not_enough_balance_to_add_sms', [balance, this.order.price]))
                    return false;
                }
                
                this.isFullSms = false

                this.sendMetrics("againservice")

                this.api.checkRepeatCode({ id: this.order.id })
                    .then((res) => {

                        if (res !== 0) {
                            res = res.split('~')

                            if (res[0] === 'queued') {
                                // console.log( 'checkRepeatCode queued')
                                clearTimeout(this.smsTimer)
                                this.smsTimer = setTimeout(this.getAdditionalSms, 2000)
                            }
                            else if (res[0] === '1') {
                                this.order.secondsleft = 600
                                this.time = 600
                                this.order.status = 1
                                this.startTimer()

                                if (this.order.opt == 'opt29' || (this.order.opt == 'opt20' && this.order.country == 'US')) {
                                    this.availableNewMessage = null
                                    this.canMakeHiddenRequest = false
                                    clearTimeout(this.hideSmsRequestTimeoutId)
                                }

                                this.getSms()

                            } else {
                                this.$emit('notify', $L('ords.impossible_to_receive_sms'))
                                Promise.reject(new Error(  $L('ords.impossible_to_receive_sms')) )
                                this.time = 0
                            }
                        } else {

                            

                            this.$emit('notify', $L('ords.impossible_to_receive_sms'))
                            Promise.reject(new Error( $L('ords.impossible_to_receive_sms')))
                            this.time = 0
                        }
                    })
                    .catch(function(ex) {
                        clearTimeout(this.smsTimer)
                        this.smsTimer = setTimeout(this.getAdditionalSms, 2000)
                    }.bind( this ) )
            },

            /**
             * Функция  getSms  отправляет запрос на получение SMS-сообщения и обрабатывает ответ. В зависимости от
             * полученного ответа выполняются различные действия, такие как установка значений для свойств объекта
             * order , вызов других функций и генерация событий.
             */

            // 2~8673330645~~null

            async getSms(){

                this.api.getCode({
                    serviceId: this.order.opt,
                    id: this.order.id,
                    country: this.order.country
                })
                    .then(async (response) => {
                        // console.log(response)
                        // response value example ↓
                        // 1~9688509627~195465~ICQ: 195465 - ваш код
                        response = response.split('~')

                        switch (response[0]) {
                            case '0' || 0:
                                this.$emit('notify', [ $L('ords.orderTimeout'), $L('ords.your_rating_reduced')] )

                                this.order.status = 1
                                break;
                            case '1' || 1:

                                if (!this.isPaid || (this.order.opt != 'opt29' && !(this.order.opt == 'opt20' && this.order.country == 'US'))) {
                                    this.$emit('got-sms')
                                }

                                this.order.status = 2
                                this.order.code = response[2]
                                this.order.fullSMS = response[3]

                                if (this.parseVoiceMessage(this.order.fullSMS)) {
                                    this.isVoice = true
                                } else {
                                    this.isVoice = false
                                }

                                if (window.gtag !== undefined) {
                                    // window.gtag('event', 'conversion', {
                                    //     'send_to': 'AW-11340379550/alOXCJeNrfAYEJ7rwZ8q',
                                    //     'value': 1.0,
                                    //     'currency': 'USD',
                                    //     'transaction_id': ''
                                    // });
                                }
                                if (this.order.fullSMS) {
                                    this.isFullSms = true
                                }

                                if (this.order.opt == 'opt29' || (this.order.opt == 'opt20' && this.order.country == 'US')) {
                                    setTimeout(() => {
                                        this.canMakeHiddenRequest = true
                                        this.createHideRequest()
                                    }, 6000)
                                }

                                this.isPaid = true
                                clearTimeout(this.smsTimer)     


                                window.smspvaTrackEvent(
                                    'activation_completed',
                                    window.smspvaActivationParams(this.order, {
                                        has_code: Boolean(response[2]),
                                        has_full_message: Boolean(response[3]),
                                    }),
                                    this.order.id
                                )

                                break;
                            case '2' || 2:
                                let response_json = JSON.parse(response[3]);
                                this.order.status = 1
                                this.other_sms_list = response_json
                                // console.log( 'Getsms res 2')
                                clearTimeout(this.smsTimer)     
                                this.smsTimer = setTimeout(this.getSms,20000)

                                break;
                            case 'queued':
                                // console.log( 'queued')
                                clearTimeout(this.smsTimer)
                                this.smsTimer = setTimeout(this.getSms,1000)

                                break;
                            case '3':
                                this.$emit('notify', [ $L('ords.error_query_parameters')] )
                                // Error in query parameters. Please create the order again or try later.
                                break;
                            case '5':
                                this.$emit('notify', [ $L('ords.user_restriction_activation')] )
                                // You have received a temporary restriction on placing orders in the activation section. You can rent a number in the "Rental" section or try placing an order on the "Activation" page later.
                                break;
                            case '50':
                                this.$emit('notify', [ $L('ords.order_already_closet')] )
                                // The order for which you made the request is already closed. Please create a new order or contact support for assistance.
                                break;
                            case '55':
                                this.$emit('notify', [ $L('ords.an_error_occurred_while_waiting_sms')] )
                                // An error occurred while sending the SMS. Please create a new order or contact support for assistance.
                                break;
                            case '6':
                            case '7':
                            case 'error':
                            case 'error1':
                            case 'error2':
                                this.$emit('notify', [ $L('ords.needAuth') , $L('ords.your_rating_reduced') ])
                                this.stopGettingSms()
                                break;
                            default:
                                throw new Error('Unknown error. Response ' + JSON.stringify(response))
                            }

                        const smsFailureReasons = {
                            '0': 'sms_timeout',
                            '3': 'invalid_parameters',
                            '5': 'activation_restricted',
                            '50': 'order_closed',
                            '55': 'sms_delivery_error',
                            '6': 'auth_or_rating_error',
                            '7': 'auth_or_rating_error',
                            'error': 'auth_or_rating_error',
                            'error1': 'auth_or_rating_error',
                            'error2': 'auth_or_rating_error',
                        }
                        const smsFailureReason = smsFailureReasons[response[0]]

                        if (smsFailureReason && this.order.status != 2) {
                            window.smspvaTrackEvent(
                                'activation_failed',
                                window.smspvaActivationParams(this.order, {
                                    failure_stage: 'sms_receive',
                                    failure_reason: smsFailureReason,
                                }),
                                String(this.order.id) + ':sms_receive'
                            )
                        }
                    })
                    .catch(function(ex) {
                        console.log(ex)
                        console.log(ex.stack)
                        clearTimeout(this.smsTimer)
                        // .bind( this )
                        this.smsTimer = setTimeout( this.getSms.bind( this ),20000)
                    // }.bind( this ) )
                    }.bind( this ) )

            },

            /**
             * Функция  stopGettingSms  останавливает таймер  smsTimer .
             */
            async stopGettingSms() {
                clearTimeout(this.smsTimer)
            },

            /**
             * Функция  copyText  копирует переданный текст в буфер обмена пользователя.
             */
            async copyText(text) {
                this.$emit('copy', text)
            },

            /**
             * Функция  timerHandler  обрабатывает таймер. Если флаг  listenTimer  установлен в значение  true  и
             * значение переменной  time  больше 0, то уменьшает значение  time  на 1. Если  time  становится равным 0
             * или меньше и значение свойства  status  объекта  order  меньше 3, то устанавливает  status  в значение 3
             * и останавливает таймер.
             */


            async timerHandler() {
                if (this.listenTimer) {
                    if (this.time > 0 && this.order.status < 3) {
                        this.time -= 1

                        this.waitingCheck()
    
                    } else {
                        this.order.status = 3
                        this.stopTimer()
                        this.waitingStep = 0
                        this.nextStepWaiting = 60
                        this.waitingShowLoading = false
                    }
                    this.order.secondsleft = this.time
                }
            },

            /**
             * Функция  parseVoiceMessage  проверяет переданное сообщение на наличие голосового сообщения. Если
             * сообщение соответствует определенному формату, то возвращает ссылку на файл с голосовым сообщением,
             * иначе возвращает  false .
             */
            parseVoiceMessage(msg) {
                const regex = /^VOICE:\s*(.+)?;\s+The\s+file:\s+https:\/\/link\.smspva\.com\/(.+)$/
                const match = regex.exec(msg)
                if (match) {
                    return 'https://link.smspva.com/' + match[2]
                } else {
                    return false;
                }
            },

            /**
             * Функция  playAudio  воспроизводит или останавливает воспроизведение аудио-файла в зависимости от
             * текущего состояния.
             */
            playAudio() {
                const audioElement = this.$refs.audioSms
                // Проверяем, играет ли аудио в данный момент

                try{
                    if (audioElement.paused) {
                        // Если аудио на паузе, запускаем его
                        audioElement.play();
                    } else {
                        // Если аудио играет, ставим его на паузу
                        audioElement.pause();
                    }
                }catch( e ){
                }
                
            }
        },

        /**
         * Функция mounted вызывается при монтировании компонента. Она проверяет, есть ли у заказа голосовое сообщение
         * и соответственно устанавливает флаг isVoice. Если у заказа есть код, то устанавливается статус 2.
         * Инициализируется оставшееся время для заказа и проверяется его статус. Если статус равен 0, то покупается
         * новый номер и устанавливаются страна и название услуги заказа. Если статус не равен 2, то запускается таймер
         * и получается SMS. Если есть оставшееся время, то таймер запускается снова. Функция timerHandler добавляется
         * как слушатель событий к окну.
         */
        async mounted() {
            if (this.order && (this.order.country == "US" || (this.order.dataToBuy && this.order.dataToBuy.country == "US"))) {
                this.waitingInfoText.us_info = $L('ords.ord_message_us_info')
            }


            if (!this.order.price) {
                this.order.price = await this.getPrice()
            }
            if (this.parseVoiceMessage(this.order.sms)) {
                this.isVoice = true
                this.order.fullSMS = this.order.sms
            } else if (this.parseVoiceMessage(this.order.code)) {
                this.isVoice = true
                this.order.fullSMS = this.order.fullSMS ? this.order.fullSMS : this.order.code
            } else if (!this.order.fullSMS && this.order.sms) {
                this.order.fullSMS = this.order.sms
            }



            if (this.order.code !== '') {
                this.order.status = 2
            }

            if (this.order.fullSMS) {
                this.isFullSms = true
            }

            this.time = this.order.secondsleft
            if (this.order.status === 0) {
                console.log ('Buy new')
                console.log ( await this.getNumber ( this.order.dataToBuy ) )
                this.order.country = this.order.dataToBuy.country
                this.order.service_name = this.order.dataToBuy.serviceName
            } else if (this.order.status !== 2) {
                await this.startTimer()
                this.getSms()
            }
            if (this.time > 0) await this.startTimer()
            window.addEventListener('tickActivation', this.timerHandler)



            if (this.order.status == 2 && (this.order.opt == "opt29" || (this.order.opt == 'opt20' && this.order.country == 'US')) && this.order.code) {
                this.canMakeHiddenRequest = true
                this.createHideRequest()
                this.isPaid = true
            }

        },
        /**
         * Функция beforeUnmount вызывается перед размонтированием компонента. Она останавливает таймер и удаляет
         * слушатель
         */
        async beforeUnmount(){
            await this.stopTimer()
            window.removeEventListener('tickActivation', this.timerHandler)
        },
        template: `
                <div v-if="!mobile" class="order_item" style="display: block">

                    <div class="" style="display:flex; align-items: start; width: 100%">

                        <div class="order_body">
                            <div class="first-row flex">
                                <div class="timer flex">
                                    <img src="/templates/New_Design/images/timer.svg" alt="">
                                    <p v-if="time > 0">{{ secondsToMinutes(time) }}</p>
                                    <p v-else-if="order.status === 0">-</p>
                                    <p v-else>Time is out</p>
                                </div>
                                <div class="phone_number flex">
                                    <template v-if="hasPhoneNumber()">
                                        <div class="click-to-copy"><button title="${ $L('ords.click_copy_number_with') }" @click="copyText(order.countrycode + order.number)" style="border-radius: 5px 0 0 5px;">{{ order.countrycode }}</button></div>
                                        <div class="click-to-copy"><button title="${ $L('ords.click_copy_number_with') }" @click="copyText(order.number)" style="border-radius: 0 5px 5px 0;">{{ order.number }}</button></div>
                                    </template>
                                    <div v-else-if="order.status === 0">${ $L('ords.ord_here_your_message') }</div>
                                    <div v-else class="phone_number__unavailable">${ $L('ords.number_unavailable') }</div>
                                </div>

                                <div class="activation_code">
                                    <div v-if="isVoice" class="click-to-copy">
                                        <button title="Click to start playing call record" @click="playAudio()">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" height="14px" width="14px">
                                                <polygon points="5 3 19 12 5 21 5 3"></polygon>
                                            </svg>
                                        </button>

                                        <button @click="startWaitDecrypt" :disabled="decryptLoading" style="margin-left: 4px; margin-bottom: 4px; min-width: 72px"> 
                                            <span v-if="!decryptLoading" style="font-size: 12px; line-height: 12px;" >${ $L('ords.title_transcribe') }</span>
                                            <img v-else src="/templates/New_Design_Multilang/images/loader_grey.gif" style="width: 14px; height: 14px; margin-bottom: -2px" alt="loader"  >
                                        </button>
                                        
                                    </div>
                                    <div v-else-if="(order.status === 2 && order.code !== '') || (order.status === 3 && order.code !== '')" class="click-to-copy">
                                        <button title="${ $L('ords.click_to_copy_code') }" @click="copyText(order.code)">{{ order.code }}</button>
                                    </div>
                                    <div v-else>${ $L('ords.ord_here_your_message') }</div>
                                </div>
                            </div>
                            <div class="second-row flex">
                                <div class="order_service">
                                    <div class="image">
                                        <img :src="'/templates/New_Design_Multilang/images/country_svg/' + order.country + '.svg'">
                                    </div>
                                    <div class="image">
                                        <img :src="'/templates/New_Design_Multilang/' + img">
                                    </div>
                                    <p>
                                        {{ order.service_name }}
                                    </p>
                                </div>
                                <div class="clue" :class="{'none': isFullSms}">
                                    <div class="additional-info" v-if="order.status === 0">${ $L('ords.getNumber') } </div>
                                    <div class="additional-info additional-info_mess" v-else-if="order.status=== 1 && time > 0">
                                        <Transition name="activation_info">
                                            <span v-if="!waitingShowLoading" v-html="waitingText(waitingStep)"></span>
                                            <img v-else src="/templates/New_Design_Multilang/images/dots_wave_animate.svg?v=222">
                                        </Transition>
                                    </div>

                                    <div class="additional-info" v-else-if="order.status === 2">${ $L('ords.SMSGot') }</div>
                                    <div class="additional-info" v-else>${ $L('ords.orderTimeout') }</div>
                                </div>

                                <div :class="{'block': isFullSms}" class="full_sms">
                                    <div v-if="isVoice" class="text">
                                        <audio :id="'audio' + order.id" controls :src="parseVoiceMessage(order.fullSMS)" ref="audioSms"></audio>
                                    </div>
                                    <div v-else class="text">
                                        {{order.fullSMS}}
                                    </div>

                                    <div v-if="decryptMessage" class="order_descrypt_msg" >
                                        {{ decryptMessage }} 
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="buttons">
                            <div v-if="order.status === 0">
                                <button class="action-button" @click="stopTimer;$emit('refuse')">
                                    ${ $L('ords.order_refuse') }
                                </button>
                            </div>
                            <div v-else-if="order.status === 1">
                                
                                <button class="action-button" @click="stopTimer;$emit('refuse')">
                                    ${ $L('ords.order_refuse')  }
                                </button>
                            
                                <button class="action-button" @click="stopTimer();$emit('ban')">
                                    ${ $L('ords.order_ban')  }
                                </button>

                            </div>
                            <div v-else-if="order.status === 2">
                                <button v-if="order.opt != 'opt29' && !(order.opt == 'opt20' && this.order.country == 'US')" class="action-button" @click="getAdditionalSms()">
                                    ${ $L('ords.order_addit_sms')  }
                                </button>

                                <button v-else class="action-button" @click="getAdditionalSms()">
                                    SMS is not suitable
                                </button>

                                <button class="action-button close-button" @click="$emit('stop-sms')">
                                    ${ $L('ords.order_close') }
                                </button>
                            </div>
                            <div v-else>
                                <button class="action-button close-button" @click="$emit('delete')">
                                    ${ $L('ords.order_close') }
                                </button>
                            </div>


                        </div>

                    </div>

                    <div v-if="availableNewMessage" class="new_message_box" >
                        <img src="/templates/New_Design_Multilang/images/new_message.svg" alt="New message" title="${ $L('ords.new_message_img_title') }">
                        <span>
                            ${ $L('ords.new_message_new_code') } &nbsp; <b @click="copyText(availableNewMessage.code)" >{{availableNewMessage.code}}</b>  &nbsp;
                            <b @click="showNewMessage">"${ $L('ords.show') }"</b>
                        </span>
                    </div>

                </div>

                <div v-else class="order_d">
                    <div class="order__box">
                        <div class="first-row-mobile flex">
                            <div class="timer flex">
                                <img src="/templates/New_Design/images/timer.svg" alt="">
                                <p v-if="time > 0"> - {{ secondsToMinutes(time) }}</p>
                                <p v-else-if="order.status === 0">-</p>
                                <p v-else>${ $L('ords.time_is_out') }</p>
                            </div>
                            <div class="order_service flex">
                                <div class="image">
                                    <img :src="'/templates/New_Design_Multilang/images/country_svg/' + order.country + '.svg'">
                                </div>
                                <div class="image">
                                    <img :src="'/templates/New_Design_Multilang/' + img">
                                </div>
                                <p>
                                    {{ order.service_name }}
                                </p>
                            </div>
                        </div>
    
                        <div class="second-row-mobile flex">
                            <p class="secondary">${ $L('ords.send_sms_to') }</p>
                            <template v-if="hasPhoneNumber()">
                                <div class="click-to-copy" style="margin-left:auto"><button title="${ $L('ords.click_copy_number_with') }" @click="copyText(order.countrycode + order.number)">{{ order.countrycode }}</button></div>
                                <div class="click-to-copy"><button title="${ $L('ords.click_copy_number_without') }" @click="copyText(order.number)" >{{ order.number }}</button></div>
                            </template>
                            <div v-else-if="order.status === 0" class="phone_number__unavailable">...</div>
                            <div v-else class="phone_number__unavailable">${ $L('ords.number_unavailable') }</div>
                        </div>

                        <div v-if="order.fullSMS !== '' || order.code !== '' " class="third-row-mobile">
                            <audio v-if="isVoice" :id="'audio' + order.id" controls :src="parseVoiceMessage( order.fullSMS ? order.fullSMS : order.code  )" ref="audioSms"></audio>
                            <div v-else-if=" order.status === 2 || order.status === 3 " class="text">
                                <p v-if=" order.fullSMS !== '' " >{{order.fullSMS}}</p>
                                <div v-if=" order.code !== '' " class="click-to-copy"><button title="${ $L('ords.click_copy_number_without') }" @click="copyText(order.code)" >{{ order.code }}</button></div>
                            </div>
                        </div>
                        
                        <div class="order__status">
                            <span v-if="order.status === 0">${ $L('ords.getNumber') }</span>

                            <div class="additional-info additional-info_mess" v-else-if="order.status=== 1 && time > 0">
                                <Transition name="activation_info">
                                    <span v-if="!waitingShowLoading" v-html="waitingText(waitingStep)"></span>
                                    <img v-else src="/templates/New_Design_Multilang/images/dots_wave_animate.svg?v=222">
                                </Transition>
                            </div>

                            <span v-else-if="decryptMessage && isVoice" class="additional-info" style="width: 100%; display: block; text-align: center">
                                {{ decryptMessage }} 
                            </span>

                            <span class="additional-info" v-else-if="order.status === 2">${ $L('ords.SMSGot') }</span>
                            <span class="additional-info" v-else>${ $L('ords.orderTimeout') }</span>
                        </div>
                        <div class="fifth-row-mobile">
                            <div class="action__btns" v-if="order.status === 0">
                                <button class="action-button" @click="stopTimer;$emit('refuse')">
                                    ${ $L('ords.order_refuse') }
                                </button>
                            </div>
                            <div class="action__btns" v-else-if="order.status === 1">
                                <button class="action-button" @click="stopTimer;$emit('refuse')">
                                    ${ $L('ords.order_refuse') }
                                </button>
                                <button class="action-button" @click="stopTimer();$emit('ban')">
                                    ${ $L('ords.order_ban') }
                                </button>
                            </div>
                            <div class="action__btns" v-else-if="order.status === 2">
                                <button class="action-button" style="margin-right: auto; background-color: var(--color-primary); color: var(--color-contrast)" @click="getAdditionalSms()">
                                    ${ $L('ords.order_addit_sms') }
                                </button>

                                <button v-if="isVoice && (order.fullSMS !== '' || order.code !== '')" @click="waitDecryptMessage" :disabled="decryptLoading" style="margin-right: auto; min-width: 85px; min-height: 29px"> 
                                    <span v-if="!decryptLoading" style="font-size: 15px; line-height: 15px;" >${ $L('ords.title_transcribe') }</span>
                                    <img v-else src="/templates/New_Design_Multilang/images/loader_grey.gif" style="width: 14px; height: 14px; margin-bottom: -2px" alt="loader"  >
                                </button>

                                <button class="action-button" @click="$emit('stop-sms')">
                                    ${ $L('ords.order_close') }
                                </button>
                            </div>
                            <div class="action__btns" v-else>
                                <button class="action-button" @click="$emit('delete')">
                                    ${ $L('ords.order_close') }
                                </button>
                            </div>


                            <div v-if="availableNewMessage" class="new_message_box" style="margin: 0px auto 10px;">
                                <img src="/templates/New_Design_Multilang/images/new_message.svg?v=2" alt="New message" title="${ $L('ords.new_message_img_title') }">
                                <span >
                                    ${ $L('ords.new_message_img_title') } <br>
                                    ${ $L('ords.new_message_new_code') } &nbsp; <b @click="copyText(availableNewMessage.code)" >{{availableNewMessage.code}}</b> &nbsp;
                                    <b @click="showNewMessage">"${ $L("ords.show") }"</b>
                                </span>
                            </div>

                        </div>
                    </div>
                </div>
        `    
    
    }
)
}
